<template>
  <div>
    <base-header type="gradient-primary" class="pb-10 pb-8 pt-5 pt-md-8">
      <!-- Card stats -->
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <potentialees-header :filters="filters" />
            <potentialees-table :potentialees="potentialees" />
            <datatable-footer
              @onNextPage="nextPage"
              @onPrevPage="prevPage"
              :showPrevPageBtn="showPrevPageBtn"
              :showNextPageBtn="showNextPageBtn"
            />
          </div>
        </div>
      </div>
    </div>

    <modal id="enrollPotentialee" title="Enroll Potentialee">
      <enroll-potentialee-form />
    </modal>
    <modal id="viewPotentialeeStats" title="View Potentialee Stats">
      <potentialee-stats :potentialee="viewingPotentialee" />
    </modal>
    <modal id="viewPotentialeeLists" title="Potentialee Lists">
      <potentialee-lists :potentialee="viewingPotentialee" />
    </modal>
    <modal id="contactPotentialee" title="Contact">
      <potentialee-contact />
    </modal>
    <modal id="viewPotentialee" title="View Potentialee">
      <edit-potentialee-form :potentialee="viewingPotentialee" readonly />
    </modal>
    <modal id="editPotentialee" title="Edit Potentialee">
      <edit-potentialee-form :potentialee="editingPotentialee" />
    </modal>
  </div>
</template>

<script>
import firebase from "@/config/firebase.js";

import PotentialeesHeader from "@/views/potentialees/components/PotentialeesHeader.vue";
import PotentialeesTable from "@/views/potentialees/components/PotentialeesTable.vue";
import DataTableFooter from "@/components/DataTable/DataTableFooter.vue";

import EnrollPotentialeeForm from "@/views/potentialees/components/EnrollPotentialeeForm.vue";
import EditPotentialeeForm from "@/views/potentialees/components/EditPotentialeeForm.vue";
import PotentialeeStats from "@/views/potentialees/components/PotentialeeStats.vue";
import PotentialeeLists from "@/views/potentialees/components/PotentialeeLists.vue";
import PotentialeeContact from "@/views/potentialees/components/PotentialeeContact.vue";

import Modal from "@/components/Modal.vue";

export default {
  components: {
    "potentialees-header": PotentialeesHeader,
    "potentialees-table": PotentialeesTable,
    "datatable-footer": DataTableFooter,
    "edit-potentialee-form": EditPotentialeeForm,
    "potentialee-stats": PotentialeeStats,
    "potentialee-lists": PotentialeeLists,
    "potentialee-contact": PotentialeeContact,
    "enroll-potentialee-form": EnrollPotentialeeForm,
    modal: Modal
  },
  data() {
    return {
      editingPotentialee: {},
      viewingPotentialee: {},
      potentialees: [],
      prevPotentialeesRef: null,
      nextPotentialeesRef: null,
      loading: false,
      showPrevPageBtn: true,
      showNextPageBtn: true,
      currentPotentialeesRef: null,
      orderBy: "enrollDate",
      orderByDir: "desc",
      locations: [],
      badges: [],
      orderByOptions: {
        enrollDate: {
          name: "Enroll Date",
          value: "enrollDate"
        },
        readyToWorkDate: {
          name: "Ready to Work Date",
          value: "readyToWorkDate"
        },
        firstName: {
          name: "First Name",
          value: "firstName"
        },
        lastName: {
          name: "Last Name",
          value: "lastName"
        },
        locationFrom: {
          name: "Location From",
          value: "locationFrom"
        }
      },
      orderByDirOptions: {
        asc: {
          name: "Ascending",
          value: "asc"
        },
        desc: {
          name: "Descending",
          value: "desc"
        }
      },
      filtersOptions: [
        {
          name: "Badges",
          field: "badgeIds",
          operator: "array-contains-any",
          value: [],
          getValueOptions: field => {
            return this.badges;
          }
        },
        {
          name: "Location",
          field: "location.id",
          operator: "==",
          value: "",
          getValueOptions: field => {
            return this.locations;
          }
        }
      ],
      filters: []
    };
  },
  computed: {
    curOrg() {
      return this.$store.state.usermain.curOrg;
    }
  },
  watch: {
    curOrg(newCurOrg, _) {
      this.getPotentialees(newCurOrg);
    }
  },
  mounted() {
    this.getPotentialees(this.curOrg);
    this.getBadges();
    this.getLocations();
  },
  methods: {
    addFilter(filter) {
      this.filters.push(filter);
      this.getPotentialees(this.curOrg);
    },
    removeFilter(index) {
      this.filters.splice(index, 1);

      this.getPotentialees(this.curOrg);
    },
    changeOrderBy(orderBy) {
      this.orderBy = orderBy;

      this.getPotentialees(this.curOrg);
    },
    changeOrderByDir(orderByDir) {
      this.orderByDir = orderByDir;

      this.getPotentialees(this.curOrg);
    },
    nextPage() {
      if (!this.loading) {
        this.loading = true;

        //if (this.potentialees) {
        this.prevPotentialeesRef = this.currentPotentialeesRef;
        //}

        this.currentPotentialeesRef = this.nextPotentialeesRef;
        this.currentPotentialeesRef
          .get()
          .then(q => this.handleNewPotentialeesData(q, "next"));
      }
    },
    currentPageRefresh() {
      if (!this.loading) {
        this.loading = true;

        this.currentPotentialeesRef
          .get()
          .then(q => this.handleNewPotentialeesData(q, "refresh"));
      }
    },
    prevPage() {
      if (!this.loading) {
        this.loading = true;

        this.nextPotentialeesRef = this.currentPotentialeesRef;
        this.currentPotentialeesRef = this.prevPotentialeesRef;

        this.currentPotentialeesRef
          .get()
          .then(q => this.handleNewPotentialeesData(q, "prev"));
      }
    },
    baseRef(orgData) {
      var potentialeesCollectionRef;

      if (orgData.type === "employer") {
        potentialeesCollectionRef = firebase
          .firestore()
          .collection("potentialees");
      } else {
        potentialeesCollectionRef = firebase
          .firestore()
          .collection("organizations/" + orgData.id + "/potentialees");
      }

      this.filters.forEach(filter => {
        if (filter.name == "Badges") {
          console.log(filter.value.map(value => value.id));
          potentialeesCollectionRef = potentialeesCollectionRef.where(
            filter.field,
            filter.operator,
            filter.value.map(value => value.id)
          );
        } else {
          potentialeesCollectionRef = potentialeesCollectionRef.where(
            filter.field,
            filter.operator,
            filter.value.id
          );
        }
      });

      return potentialeesCollectionRef.orderBy(this.orderBy, this.orderByDir);
    },
    getBadges() {
      const self = this;

      firebase
        .firestore()
        .collection("badges/")
        .orderBy("name", "asc")
        .get()
        .then(function(querySnapshot) {
          const documents = querySnapshot.docs.map(doc => {
            const docData = doc.data();
            docData.id = doc.id;

            return docData;
          });

          self.badges = Object.values(documents);
        });
    },
    getLocations() {
      const self = this;

      firebase
        .firestore()
        .collection("locations/")
        .get()
        .then(function(querySnapshot) {
          const documents = querySnapshot.docs.map(doc => {
            const docData = doc.data();
            docData.id = doc.id;

            return docData;
          });

          self.locations = Object.values(documents);
        });
    },
    getPotentialees(orgData) {
      if (orgData.id != null) {
        this.loading = true;

        this.currentPotentialeesRef = this.baseRef(orgData).limit(10);

        this.currentPotentialeesRef.get().then(this.handleNewPotentialeesData);
      }
    },
    handleNewPotentialeesData(querySnapshot, buttonClicked = "initial") {
      const documents = querySnapshot.docs.map(doc => {
        const docData = doc.data();
        docData.id = doc.id;

        return docData;
      });

      this.potentialees = documents;

      const firstDocument = querySnapshot.docs[0];
      const lastDocument = querySnapshot.docs[querySnapshot.docs.length - 1];

      if (firstDocument) {
        this.prevPotentialeesRef = this.baseRef(this.curOrg)
          .endBefore(firstDocument)
          .limitToLast(10);
      }

      if (lastDocument) {
        this.nextPotentialeesRef = this.baseRef(this.curOrg)
          .startAfter(lastDocument)
          .limit(10);
      }

      if (documents.length <= 0) {
        if (buttonClicked === "next") {
          this.showPrevPageBtn = true;
          this.showNextPageBtn = false;
        }
        if (buttonClicked === "prev") {
          this.showPrevPageBtn = false;
          this.showNextPageBtn = true;
        }
      } else {
        this.showPrevPageBtn = true;
        this.showNextPageBtn = true;
      }

      this.loading = false;
    }
  }
};
</script>
<style></style>
